import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _str from "shared/util/_str";

const Sms2Factor = (props) => {
	const { isSendingCode, send2FaOTP } = props;

	const sendCode = (e) => {
		e.preventDefault();

		if (!isSendingCode) {
			send2FaOTP();
		}
	};

	return (
		<form className="oknf oknf--gray login-form login-sms" onSubmit={sendCode}>
			<div className="login-fields">
				<div className="login-fields-text--sms2fa">
					{_str("Keep your account safe by authorizing your phone number again.")}
				</div>
			</div>

			<div className="login-actions">
				<button
					type="submit"
					className={classnames("login-actions-button", {
						"isSubmitting": isSendingCode,
					})}
				>
					{isSendingCode ? _str("Sending Code") : _str("Send Code")}
				</button>
			</div>
		</form>
	);
};

Sms2Factor.propTypes = {
	isSendingCode: PropTypes.bool.isRequired,
	send2FaOTP: PropTypes.func.isRequired,
};

export default Sms2Factor;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/Sms2Factor.jsx